import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/reset.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import '@/assets/base.css'
import {Pagination, Dialog,Select,Option,Dropdown, DropdownMenu, DropdownItem} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import FastClick from 'fastclick'
FastClick.attach(document.body);
// 跳转页面时返回顶部
router.afterEach((to, from) => {
  window.scrollTo(0, 0)
})
 
 

Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Select)
Vue.use(Option)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.prototype.$VUE_APP_PUBLIC = process.env.VUE_APP_PUBLIC;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
